import { useDispatch, useSelector } from 'react-redux';
import { getNewPlan } from '@/services/apis/modules/plans';
import { setUserData } from '@/stores/modules/user';

const useGetNewPlans = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.userData);

  const fetchNewPlan = async () => {
    try {
      const res = await getNewPlan();
      
      if (res?.status) {
        dispatch(
          setUserData({
            ...userData,
            user: {
              ...userData.user,
              plan: res?.data,
            },
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { fetchNewPlan };
};

export default useGetNewPlans;